<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
  <div class="content-wrapper">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 col-xl-8 mb-4 mb-xl-0">
          <h3 class="font-weight-bold">Welcome <span class="text-primary text-capitalize">{{user.fulname}}</span></h3>
        </div>
        <div class="col-12 col-xl-4">

        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">

    <div v-if="user.role == 3" class="col-md-6 col-sm-6 col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body justify-content-center align-items-center text-center py-5" id="">
           <h4 class="mb-3">
            Switch to Another Branch
        </h4>

        <p class="text-muted mb-4">
            Choose a branch to manage its operations and view its information.
        </p>
<div class="d-flex w-100">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_switch" class="form-select form-control">
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div>

                                        <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                          <button @click="switchUpdatedBranch" class="btn btn-primary mt-3">Switch To Branch</button>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-6 col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">

          <h4 class="card-title">Change Password</h4>

          <div class="mt-3">

            <div>
              <div class="form-group">
                <label for="current_password">Current Password</label>
                <input class="form-control" type="password" id="current_password" v-model="current_password" />
              </div>

              <div class="form-group">
                <label for="new_password">New Password</label>
                <input class="form-control" type="password" id="new_password" v-model="new_password" />
              </div>

              <div class="form-group">
                <label for="confirm_password">Confirm Password</label>
                <input class="form-control" type="password" id="confirm_password" v-model="confirm_password" />
              </div>

              <div v-if="loading_passwaord" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
              <button id="change_password" @click="updatedPassword" class="btn btn-primary">Reset Password</button>
            </div>

          </div>
        </div>
      </div>
    </div>



  </div>
</div>

</template>
<script>
import axios from "axios";

import * as CryptoJS from 'crypto-js';

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_passwaord:false,
            filter_branch:"",
            branches: [],
            branch_switch:"",
            og_branches: [],
            current_password:"", 
            new_password:"", 
            confirm_password:"",
            user: this.$attrs.user
        };
    },
    methods: {

        async getAllBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/all-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = response.data.branches;
                this.og_branches = response.data.branches;

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

               async switchUpdatedBranch() {

            var branch_id = this.branch_switch

            var branches = this.og_branches

            this.loading = true
           
            var response = await axios
                .post(this.$store.state.api_url+"/switch-branch",{branch_id})
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                //window.location.reload();
                this.loading = false

                const branch = branches.find(item => item.id == branch_id);
                var branch_name = branch.name
                var branch_region = branch.region
                var branch_location = branch.location

                console.log(branch)

                this.switchBranch(branch_id, branch_name, branch_region, branch_location)
               
            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

                   async updatedPassword() {

            var new_password = this.new_password
            var current_password = this.current_password
            var confirm_password = this.confirm_password

            if (new_password.length < 8) {
 alert('New password must not be less than 8 character')
 return true
            }
      if (new_password != confirm_password) {
 alert('New password do not match confirmed password')
 return true
      }

      this.loading_passwaord = true
           
            var response = await axios
                .post(this.$store.state.api_url+"/auth/change-password",{current_password, new_password, confirm_password})
                .catch((errors) => {
                    this.loading_passwaord = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading_passwaord = false
                var message = response.data.message;
                this.$toast.success(message, { duration: 5000, dismissible: true });
               
            } else {
                this.loading_passwaord = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },


         switchBranch(branch_id, branch_name, branch_region, branch_location) {
        try {
            // Get encrypted user from localStorage
            const user_cry = localStorage.getItem("user");

            if (!user_cry) {
                console.error("User data not found in localStorage");
                return;
            }

            // Decrypt user
            const decrypted = CryptoJS.AES.decrypt(
                user_cry,
                "user"
            ).toString(CryptoJS.enc.Utf8);

            // Convert JSON string to object
            const user = JSON.parse(decrypted);

            // Set new branch ID
            user.branch_id = branch_id;
            user.branch_name = branch_name;
              user.branch_location = branch_location;
                user.branch_region = branch_region;

            // Encrypt updated user
            const encrypted = CryptoJS.AES.encrypt(
                JSON.stringify(user),
                "user"
            ).toString();

            // Save back to localStorage
            localStorage.setItem("user", encrypted);

            //console.log("user: "+encrypted)

           // console.log("Branch switched successfully:", branch_id);

            //var message = "Branch switched successfully:";
            //this.$toast.success(message, { duration: 5000, dismissible: true });

            window.location.reload();

        } catch (error) {
            console.error("Failed to switch branch:", error);
        }
    }



    },
      computed: {


},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )
            })
        },
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getAllBranch()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
